import React from 'react'
import logo from '../../assets/logo.png'


export default function Header() {
  return (
    <div className='flex justify-between w-full p-1 bg-white shadow-md px-5'>
        <div className='flex items-center gap-2'> 
        <img className='w-[60px] object-contain' src={logo} />
        <p className='font-bold text-md tracking-wide uppercase opacity-[0.6]'>Super Admin</p>
            {/* <a href='/' target='_blang' className='text-[14px] bg-main px-5 py-2 rounded-sm text-white'>Visit Profile</a> */}
        </div>
        <div className='flex gap-2 items-center'>
            {/* <img className='w-[35px] h-[35px] rounded-full object-cover' alt='profile' src={Instructor} /> */}
            <div className='flex flex-col gap-1'>
                <p className='text-black text-[14px] font-bold leading-none'>Admin</p>
                <p className='text-black text-[12px] leading-none'>admin</p>
            </div>
        </div>
    </div>
  )
}
